module.exports = __webpack_public_path__ + "static/media/landing.4010d615.jpeg";